@if (effectiveContext(); as ctx) {
  <section class="hd-gate-graph-panel">
    <hd-gate-graph
      class="hd-gate-graph-panel__graph"
      [gate]="ctx.gate"
      [keynote1]="keynote1()"
      [keynote2]="keynote2()"
      [lineKeynotes]="lineKeynotes()"
      [centerIconUrl]="centerIconUrl()"
      [centerName]="centerName()"
      [palette]="palette"
      [spacing]="spacing"
      [activations]="ctx.activations"
      [showFullLabel]="toggleLabels().showFull"
      [showHighlightLabel]="toggleLabels().showHighlight"
    />
  </section>
}
